import React from 'react';
import { useParams } from 'react-router-dom';
import Course from './course/course';
import NewCourse from './new-course/index';

const NEW_COURSE_TYPES = [
  'education',
  'general-staff',
  'cybersecurity2026',
  'finance',
  'sme',
  'student-training',
  'civil',
];

const MainCourse: React.FunctionComponent<any> = (props) => {
  const param = useParams();
  const p_course = param.course;
  const isNewCourse = NEW_COURSE_TYPES.includes(p_course as string);

  return isNewCourse ? <NewCourse /> : <Course />;
};

export default MainCourse;
